import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import { FC, useEffect, useMemo } from 'react';

import { themes } from 'app/components/v2/theme';
import { useCanUseDarkMode, useUiTheme } from 'app/hooks/useUiTheme';
import { PropsWithOnlyChildren } from 'app/types';

const UiThemeProvider: FC<PropsWithOnlyChildren> = ({ children }) => {
  const {
    prefersDarkMode,
    theme,
  } = useUiTheme();

  const canUseDarkMode = useCanUseDarkMode();

  const selectedTheme = useMemo(() => {
    if (!canUseDarkMode) {
      return themes.light;
    }

    if (theme === 'system') {
      return prefersDarkMode ? themes.dark : themes.light;
    }

    return theme === 'dark' ? themes.dark : themes.light;
  }, [canUseDarkMode, prefersDarkMode, theme]);

  useEffect(() => {
    const body = document.querySelector('body');

    if (body) {
      // add data-theme attribute to body
      body.setAttribute('data-theme', selectedTheme.mode);
    }
  }, [selectedTheme]);

  return (
    <EmotionThemeProvider theme={selectedTheme}>
      {children}
    </EmotionThemeProvider>
  );
};

export default UiThemeProvider;
